import AppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';

const StyledAppBar = styled(AppBar)(({ theme }) => ({
	'& .username, & .email': {
		transition: theme.transitions.create('opacity', {
			duration: theme.transitions.duration.shortest,
			easing: theme.transitions.easing.easeInOut
		})
	},

	'& .avatar': {
		background: theme.palette.background.default,
		transition: theme.transitions.create('all', {
			duration: theme.transitions.duration.shortest,
			easing: theme.transitions.easing.easeInOut
		}),
		bottom: 0,
		'& > img': {
			borderRadius: '50%'
		}
	}
}));

function UserNavbarHeader(props) {
	const user = useSelector(selectUser);

	return (
		<StyledAppBar
			position="static"
			color="primary"
			className="user relative z-0 mb-32 flex flex-col items-center justify-center pb-64 pt-24 shadow-0"
		>
			<Typography className="username mb-4 whitespace-nowrap text-18 font-semibold" color="inherit">
				{user.data.displayName}
			</Typography>
			<Typography className="email whitespace-nowrap text-13 font-medium opacity-50" color="inherit">
				{user.data.email}
			</Typography>
			<div className="absolute bottom-0 -mb-44 flex items-center justify-center">
				<Avatar
					className="avatar box-content h-72 w-72 p-8"
					alt="user photo"
					src={
						user.data.photoURL && user.data.photoURL !== ''
							? user.data.photoURL
							: 'assets/images/avatars/profile.jpg'
					}
				/>
			</div>
		</StyledAppBar>
	);
}

export default UserNavbarHeader;
